// extracted by mini-css-extract-plugin
export var deliveryRow = "_rd-a";
export var fixedHeight = "_rd-4";
export var freightLogo = "_rd-9";
export var fullWidth = "_rd-3";
export var priceColumn = "_rd-5";
export var radioSelected = "_rd-7";
export var radioUnselected = "_rd-6";
export var selectedOption = "_rd-2";
export var selectedOptionContainer = "_rd-1";
export var selection = "_rd-0";
export var tallSkeletonText = "_rd-8";